<template>
  <div>
    <div class="col-md-12 no-print">
      <div class="row">
        <div class="col-md-2 text-center">
          <button class="btn btn-block btn-info" @click="changeType('shelf')">
            Show Shelf
          </button>
        </div>
        <div class="col-md-2 text-center">
          <button
            class="btn btn-block btn-info"
            @click="doPackaging()"
            v-if="!isReadOnlyUser"
          >
            Do Packaging
          </button>
        </div>
        <div class="col-md-2 text-center">
          <button
            v-if="type == 'carton' && !isReadOnlyUser"
            class="btn btn-block btn-light-blue"
            @click="shipment()"
          >
            Shipment
          </button>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4 text-right" v-if="enableResetButtons">
          <button
            v-if="!isReadOnlyUser"
            class="btn btn-danger"
            @click="resetShelf()"
          >
            Reset Shelf
          </button>
          <button
            v-if="donePackagingOnce && !isReadOnlyUser"
            class="btn btn-danger no-print"
            @click="resetPackaging()"
          >
            Reset Packaging
          </button>
        </div>
      </div>
      <br />
    </div>

    <div class="row col-md-12 -no-print">
      <div class="col-md-4">
        <div class="input-group transparent" v-if="type == 'shelf'">
          <span class="input-group-addon">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
          <input
            type="text"
            v-model="keyword"
            @keyup.enter="searchShelf()"
            class="form-control"
            placeholder="Keyword ... "
          />
        </div>
        <br />
      </div>
    </div>

    <!-- shelf -->
    <div class="col-md-12 no-print" v-if="type == 'shelf'">
      <div class="row">
        <div class="grid-title row">
          <div class="col-md-6">
            <button class="btn btn-primary" @click="printShelf()">
              <i class="fa fa-print" aria-hidden="true"></i> Print
            </button>
            <br/>
            Total Shirt - {{ ezy.comma(totalItems("App\\Models\\ShirtOrder"), 0) }} ,
            Total Curlys - {{ ezy.comma(totalProductionItems('curly'), 0) }} ,
            Total Kellerfaltenbluses - {{ ezy.comma(totalProductionItems('kellerfaltenbluse'), 0) }} ,
          </div>
        </div>
        <div class="col-md-12" v-for="(list, index) in lists" :key="list.field">
          <div class="grid bg-white">
            <div class="grid-body consultant-name">
              <h4 class="text-bold">
                <span class="text-capitalize">{{
                  list.field.replace(/_/g, " ")
                }}</span>
                <span v-if="list.field != 'mixed_box'">
                  - {{ list.recipient }} ( {{ list.recipient_id }} ) ({{
                    list.recipient_type
                  }})
                </span>
                <span class="badge badge-success float-right total-item">
                  {{ list.totalItems }}
                  <span v-if="list.totalItems > 1">Items</span>
                  <span v-else>Item</span>
                </span>
              </h4>
            </div>
            <div class="grid-body shirt-lists">
              <div class="list-group">
                <a
                  class="list-group-item text-bold"
                  v-for="(item, subIndex) in list.items"
                  :key="item.id"
                >
                  <router-link
                    :to="{ path: '/shirt/detail/' + item.production_item_id }"
                    v-if="
                      item.production_item_type == 'App\\Models\\ShirtOrder'
                    "
                  >
                    Order Number -
                    {{ item.production_item_id }} (Shirt Order)
                  </router-link>

                  <router-link
                    :to="{ path: 'curly_production/detail/' + item.production_item_id }"
                    v-if="
                      item.production_item_type === 'App\\Models\\ProductionItem' && item.product_category === 'curly'
                    "
                  >
                    Order Number -
                    {{ item.production_item_id }} (Curly)
                  </router-link>

                  <router-link
                    :to="{ path: '/kfb/detail/' + item.production_item_id }"
                    v-if="
                      item.production_item_type === 'App\\Models\\ProductionItem' && item.product_category === 'kellerfaltenbluse'
                    "
                  >
                    Order Number -
                    {{ item.production_item_id }} (Kellerfaltenbluse)
                  </router-link>
                  <router-link
                    :to="{ path: '/product_order/detail/' + item.product_order_id }"
                    v-if="
                      item.production_item_type === 'App\\Models\\ProductionItem'
                      && item.product_category !== 'curly'
                      && item.product_category !== 'kellerfaltenbluse'
                    "
                  >
                    Order Number -
                    {{ item.production_item_id }} (Other: {{ item.product_category }})
                  </router-link>
                  <span
                    class="btn btn-xs btn-danger remove-shirt"
                    @click="removeItem(index, subIndex)"
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Remove
                  </span>
                  <span class="badge badge-primary">
                    Fabric -
                    {{ $Fabric.getCode(item.fabric_id) }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- cartons -->
    <div class="col-md-12 print-page" v-if="type == 'carton'">
      <div class="grid bg-white">
        <div class="grid-title no-print">
          <div class="row">
            <div class="col-md-6">
              <h4 class="text-bold">Packaging</h4>
            </div>
          </div>
        </div>
        <div class="grid-body">
          <button class="btn btn-success no-print" @click="printPackaging()">
            Print Packaging
          </button>
          <PackagingBox :cartons="cartons" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PackagingBox from "./components/PackagingBox";
export default {
  components: {
    PackagingBox,
  },
  data() {
    return {
      lists: [],
      donePackagingOnce: false,
      keyword: null,
      columnFilters: {},
      cartons: [],
      type: "shelf",
      enableResetButtons: false,
      isReadOnlyUser: false,
    };
  },

  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getLists();
  },

  methods: {
    changeType(type) {
      this.type = type;
    },

    totalItems(type) {
      let total = 0;
      this.lists.forEach((list) => {
        list.items.forEach((item) => {
          if (item.production_item_type == type) {
            total++;
          }
        });
      });
      return total;
    },

    totalProductionItems(category) {
      let total = 0;
      this.lists.forEach((list) => {
        list.items.forEach((item) => {
          if (item.product_category === category && item.production_item_type === 'App\\Models\\ProductionItem') {
            total++;
          }
        });
      });
      return total;
    },

    async getLists() {
      try {
        let res = await axios.post("packaging/shelf/items", {
          columnFilters: this.columnFilters,
        });
        this.lists = res.data.shelfItems;
        this.donePackagingOnce = res.data.donePackagingOnce;
        this.enableResetButtons = res.data.enableResetButtons;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    searchShelf() {
      this.columnFilters = {
        field: this.keyword,
        production_item_id: this.keyword,
        fabric_id: this.keyword,
      };
      this.getLists();
    },

    async doPackaging() {
      if (await ezy.confirm("Are you sure?", "YES")) {
        try {
          let res = await axios.get("packaging/shelf/carton/package");
          this.sortBoxes(res.data);
          this.cartons = res.data;
          this.donePackagingOnce = true;
          this.type = "carton";
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async resetPackaging() {
      let result = await Swal.fire({
        title: "Are you sure?",
        text:
          "Do you really want to delete the packaging? all Carton will be cleared!",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        try {
          let res = await axios.put("packaging/shelf/carton/reset");
          if (res) {
            this.donePackagingOnce = false;
            toastr.success("SUCCESS");
          }
          this.type = "shelf";
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async shipment() {
      let result = await Swal.fire({
        title: "Are you sure?",
        text: "Ready for shipment? Shelf items will be killed!",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        try {
          let res = await axios.post("packaging/shipment/create");
          this.cartons = [];
          this.lists = [];
          this.donePackagingOnce = false;
          toastr.success("SUCCESS");
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async resetShelf() {
      let result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete all items from the shelf?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        try {
          let res = await axios.post("packaging/shelf/reset");
          if (res) {
            this.donePackagingOnce = false;
            this.type = "shelf";
            this.lists = [];
          }
          toastr.success("SUCCESS");
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async removeItem(index, subIndex) {
      let data = this.lists[index].items[subIndex];
      let box = this.lists[index];
      let result = await Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to delete item from this Box (${box.field}) ?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        try {
          let res = await axios.delete(
            "packaging/shelf/" + data.production_item_id,
            {
              params: {
                itemType: data.production_item_type,
              },
            }
          );
          if (res) {
            this.lists[index].items.splice(subIndex, 1);
            let totalShirtLeft = (box = this.lists[index].items.length);
            if (totalShirtLeft == 0) {
              this.lists.splice(index, 1);
            }
            toastr.success("SUCCESS");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async printShelf() {
      let result = await Swal.fire({
        title: "Are you sure to Print?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        try {
          let res = await axios({
            url: "packaging/shelf/print",
            method: "GET",
            responseType: "blob", // important
          });
          if (res) {
            var url = URL.createObjectURL(res.data);
            window.open(url, "_blank");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    printPackaging() {
      window.print();
    },
    /**
     * Sort the packaging (grouped by recipient ID) boxes alphabetically
     */
    sortBoxes(data) {
      data.forEach((carton) => {
        /**
         * Step 1. Group the list of boxes by recipientId
         * This function will return:
         *
         * {
         *      recipient_1 : [box1, box2, box3 ...],
         *      recipient_2 : [box4, box5, box6 ...],
         *      recipient_3 : [box7, box8, box9 ...]
         * }
         *
         */
        let groupedRecipientBoxes = {};
        carton.boxes.forEach((box) => {
          if (!groupedRecipientBoxes.hasOwnProperty(box.recipientId)) {
            groupedRecipientBoxes[box.recipientId] = [];
          }
          groupedRecipientBoxes[box.recipientId].push(box);
        });

        /**
         * Step 2. Sort each recipient boxes alphabetically.
         *
         * This function will return:
         *
         * {
         *      0 : [box1, box3, box2 ...],
         *      1 : [box4, box5, box6 ...],
         *      2 : [box8, box7, box9 ...]
         * }
         *
         * with [box1, box3, box2 ...] sorted alphabetically based on the `name` property (box1.name < box3.name < box2.name)
         *
         */
        groupedRecipientBoxes = Object.values(groupedRecipientBoxes).map(
          (boxes) => {
            return boxes.sort((box1, box2) => {
              return box1.name.localeCompare(box2.name, undefined, {
                numeric: true,
                sensitivity: "base",
              });
            });
          }
        );

        /**
         * Step 3. Sort the group of recipient boxes alphabetically based on the name of first box in each group.
         *
         * This function will return:
         *
         * {
         *      0 : [box1, box3, box2 ...],
         *      1 : [box8, box7, box9 ...],
         *      2 : [box4, box5, box6 ...]
         *
         *  with box1.name < box8.name < box4.name
         * }
         */
        const sortedRecipientBoxes = groupedRecipientBoxes.sort(
          (recipientBoxes1, recipientBoxes2) => {
            return recipientBoxes1[0].name.localeCompare(
              recipientBoxes2[0].name,
              undefined,
              { numeric: true, sensitivity: "base" }
            );
          }
        );

        /**
         * Step 4. Flatten the previous group of recipient boxes to a single dimension array.
         * This function will return:
         *
         * [box1, box3, box2, ..., box8, box7, box9, ..., box4, box5, box6, ...]
         */
        carton.boxes = sortedRecipientBoxes.flat();
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.text-white {
  color: white !important;
}
.shirt-lists {
  padding: 5px;
}
.list-group {
  margin-bottom: 0px;
}
.total-item {
  font-size: 19px;
}
.consultant-name {
  padding: 5px 20px;
}
.grid-title {
  padding: 20px !important;
  font-weight: bold;
}
.remove-shirt {
  display: none;
  padding: 3px 13px;
}
.list-group-item {
  padding: 25px 15px;
}
.list-group-item:hover .remove-shirt {
  display: inline;
}
.no-print {
  margin-left: 25px;
}
.btn-light-blue {
  background-color: #0dcaf0;
  color: #000;
}
@media print {
  @page {
    size: "A4"; /* landscape */
    margin: 4mm;
  }
  .no-print,
  .no-print * {
    display: none !important;
  }
  .page-sidebar {
    display: none !important;
  }
  .print-page {
    margin-top: -100px;
    .grid {
      box-shadow: none !important;
      border: 1px solid gray !important;
      padding: 2px !important;
    }
  }
}
</style>
